import { render, staticRenderFns } from "./SmileLinkage.vue?vue&type=template&id=00d2459a"
import script from "./SmileLinkage.vue?vue&type=script&lang=js"
export * from "./SmileLinkage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports